import { combineReducers } from 'redux';

import repeatedFrom from 'state/mrDistribution/repeated-from';
import shipments from 'state/mrDistribution/shipments';
import extras from 'state/mrDistribution/extras';
import quote from 'state/mrDistribution/quote';
import ui from 'state/mrDistribution/ui';

const data = combineReducers({
  shipments,
  extras,
  repeatedFrom,
});

const reducer = combineReducers({
  data,
  ui,
  quote,
});

export default reducer;
